define('presentation/settings/billing/plans/viewModels/plansViewModel',[
    'businessServices/router/router',
    'businessServices/authentication/sessionAccountInfo',
    'common/promises/promiseFactory',
    'constants/billingPackageTypeConstants',
    'constants/colorConstants',
    'presentation/common/actionModal/viewModels/actionModalViewModel',
    'presentation/common/modal',
    'presentation/settings/billing/plans/facades/plansFacade',
    'presentation/settings/billing/plans/viewModels/removePlanActionModalViewModel',
    'settings/navigationConfiguration'
], function () {
    return function () {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const RemovePlanActionModalViewModelConstructor = require('presentation/settings/billing/plans/viewModels/removePlanActionModalViewModel');

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _colorConstants = require('constants/colorConstants');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('businessServices/router/router');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

        let _facade = null;
        let _modalService = null;

        const _buildRemoveModal = (planPresentationObject, constraints) => {
            const constructorParams = [planPresentationObject, constraints, self.navigateToCloseAccount];
            self.actionModal
                .clearModal()
                .setContentViewModel(RemovePlanActionModalViewModelConstructor, constructorParams)
                .setHeaderText({i18n: 'removePlanActionModal:header'})
                .setSubmitButtonText({i18n: 'continue'})
                .shouldScrollIntoView(false);
        };

        const _refreshPlans = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getAccountPlans()
                    .fail(promise.reject)
                    .done((plans) => {
                        self.plans(plans);
                        promise.resolve();
                    });
            });
        };

        const _showRemovePlanModal = (planPresentationObject, constraints) => {
            _buildRemoveModal(planPresentationObject, constraints);
            self.actionModal.showModal();
        };

        self.actionModal = null;
        self.plans = ko.observableArray([]);
        self.editPlanBaseUrl = _navigationConfiguration.routesById.addPlan.baseUrl;
        self.closeAccountUrl = _navigationConfiguration.routesById.closeAccount.url;
        self.longClickSpinnerColor = _colorConstants.colorSecondaryCool200;

        self.showActivatePlanButton = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.editPlan = (planPresentationObject) => {
            switch (planPresentationObject.type()) {
                case _billingPackageTypes.telephony.id:
                    return _router.navigate(self.editPlanBaseUrl + _billingPackageTypes.telephony.key);
                case _billingPackageTypes.liveReceptionist.id:
                    return _router.navigate(self.editPlanBaseUrl + _billingPackageTypes.liveReceptionist.key);
                case _billingPackageTypes.webChat.id:
                    return _router.navigate(self.editPlanBaseUrl + _billingPackageTypes.webChat.key);
                case _billingPackageTypes.outboundCalling.id:
                    return _router.navigate(self.editPlanBaseUrl + _billingPackageTypes.outboundCalling.key);
                default:
                    return;
            }
        };

        self.launchRemovePlan = (planPresentationObject) => {
            const billingPackageId = planPresentationObject.billingPackageId;
            return _promiseFactory.deferIndefinitely((promise) => {
                _facade.getConstraints(billingPackageId)
                    .done((constraints) => {
                        _showRemovePlanModal(planPresentationObject, constraints);
                        promise.resolve();
                    });
            });
        };

        self.navigateToCloseAccount = () => {
            _modalService.closeModal(self.actionModal);
            _router.navigate(self.closeAccountUrl);
        };

        self.activatePlan = (planPresentationObject) => {
            return _promiseFactory.deferWithMinimumWait((promise) => {
                _facade.activatePlan(planPresentationObject.packageId, planPresentationObject.type())
                    .fail(promise.reject)
                    .done(() => {
                        self.plans().forEach((p) => {
                            if (p.packageId === planPresentationObject.packageId) {
                                p.isOnboardingComplete(true);
                            }
                        });
                        promise.resolve();
                    });
            });
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/billing/plans/facades/plansFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            self.actionModal = new ActionModalViewModelConstructor();

            const ModalServiceConstructor = require('presentation/common/modal');
            _modalService = new ModalServiceConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _refreshPlans();

            return _promiseFactory.wait();
        };
    };
});
